import React, { useState, useEffect } from 'react';
import { Button, Container, Grid, TextField } from '@material-ui/core';
import { getBacchusURL, handleErrorToast, remainingTime } from '../shared/Functions';
import { QueriesVService } from '../../services/V2/aurascope';
import { Autocomplete } from '@material-ui/lab';
import { authProvider } from '../../services/Security';

export const MeterImages = (props) => {
    const [queryParams, setQueryParams] = useState<any>();
    const [district, setDistrict] = useState<any>(null);
    const [route, setRoute] = useState<any>(null);
    const [meter, setMeter] = useState<any>(null);
    const [user, setUser] = useState<any>(null);
    const [createdBy, setCreatedBy] = useState<any>(null);
    const [formData, setFormData] = useState<any>({
        fromCreatedAt: "",
        toCreatedAt: "",
    });
    const [resetToken, setResetToken] = useState<boolean>(false);
    const [count, setCount] = useState<number>(0);
    const url = getBacchusURL()

    useEffect(() => {
        if(!district) return;
        loadIframe()
        setResetToken(false)
    }, [resetToken, district])// eslint-disable-line react-hooks/exhaustive-deps

    const loadIframe = () => {
        setCount(count+1)
        authProvider.getNexusTokenFull().then(token => {
            setTimeout(() => setResetToken(true), remainingTime(token.tokenExpires))
            const frame = document.getElementById('meter-images') as HTMLIFrameElement;
            frame?.contentWindow?.postMessage(JSON.stringify({
                token: token,
                districtId: district?.id,
                routeId: route?.id,
                meterId: meter?.id,
                userId: user?.id,
                createdById: createdBy?.id,
                fromCreatedAt: formData.fromCreatedAt,
                toCreatedAt: formData.toCreatedAt
            }), url);
        })
    }

    useEffect(() => {
        setDistrict(props.district)
        if(props.district){
            QueriesVService.queriesVGetForReads(props.district.operatorId, props.district.id)
                .then(x => {
                    setQueryParams(x)
                })
                .catch(err => err.message !=="Not Found" && props.errorToast(handleErrorToast(err)))
        }
    }, [props.district])// eslint-disable-line react-hooks/exhaustive-deps

    const handleReset = () => {
        setFormData({
            fromCreatedAt: "",
            toCreatedAt: "",
        })
        setRoute(null);
        setMeter(null);
        setUser(null);
        setCreatedBy(null);
        loadIframe()
    }

    const handleChange = event => {
        let name = event.target.name;
        let value = event.target.value;

        if (event.target.type === "checkbox") {
            name = event.target.id;
            value = event.target.checked
        }
        setFormData({
            ...formData,
            [name]: value
        })
    }

    return (
        <React.Fragment>
            <Container maxWidth="xl">
                <div style={{backgroundColor: "white", borderRadius: "10px"}}>
                    <div style={{padding: '15px', margin:'0px'}}>
                        <h6 style={{textAlign: "left", fontSize:"1.25rem", letterSpacing:"0.0075em", lineHeight:"1.6"}}>Meter Images</h6>
                        <div className="row col-12">
                            <div className="row col-6">
                                <Grid item xs={6}
                                    container={true}
                                    alignContent="flex-start">
                                    <TextField
                                        label="From Created At"
                                        name="fromCreatedAt"
                                        type="date"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        value={formData === undefined ? "" : formData.fromCreatedAt}
                                        onChange={handleChange}
                                        style={{width: "140px"}}
                                    />
                                </Grid>
                                <Grid item xs={6}
                                    container={true}
                                    alignContent="flex-start">
                                    <TextField
                                        label="To Created At"
                                        name="toCreatedAt"
                                        type="date"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        value={formData === undefined ? "" : formData.toCreatedAt}
                                        onChange={handleChange}
                                        style={{width: "140px"}}
                                    />
                                </Grid>
                                <Grid item xs={5}
                                    container={true}
                                    alignContent="flex-start">
                                    <Autocomplete
                                        value={route || {}}
                                        id="route"
                                        options={queryParams?.meterRoutes?.sort((a,b) => a.name.localeCompare(b.name)) ?? []}
                                        getOptionLabel={(option) => option?.name ?? ""}
                                        renderOption={(option, { selected }) => (
                                            <div style={{ width: "100%", textAlign:"center" }}>{option?.name}</div>
                                        )}
                                        style={{ width: 250,paddingTop: "10px", color: "#fff" }}
                                        renderInput={(params) => <TextField {...params} label="Route" variant="outlined" />}
                                        getOptionSelected={(o, v) => o.id === v.id}
                                        onChange={(e, o) => {
                                                setRoute(o);
                                            }}
                                        />
                                </Grid>
                                <Grid item xs={1} />
                                <Grid item xs={5}
                                    container={true}
                                    alignContent="flex-start">
                                    <Autocomplete
                                        value={meter || {}}
                                        id="meter"
                                        options={queryParams?.meters?.sort((a,b) => a.name.localeCompare(b.name)) ?? []}
                                        getOptionLabel={(option) => option?.name ?? ""}
                                        renderOption={(option, { selected }) => (
                                            <div style={{ width: "100%", textAlign:"center" }}>{option?.name}</div>
                                        )}
                                        style={{ width: 250,paddingTop: "10px", color: "#fff" }}
                                        renderInput={(params) => <TextField {...params} label="Meter" variant="outlined" />}
                                        getOptionSelected={(o, v) => o.id === v.id}
                                        onChange={(e, o) => {
                                                setMeter(o);
                                            }}
                                        />
                                </Grid>
                                <Grid item xs={5}
                                    container={true}
                                    alignContent="flex-start">
                                    <Autocomplete
                                        value={user || {}}
                                        id="user"
                                        options={queryParams?.meterReaders?.sort((a,b) => a.name.localeCompare(b.name)) ?? []}
                                        getOptionLabel={(option) => option?.name ?? ""}
                                        renderOption={(option, { selected }) => (
                                            <div style={{ width: "100%", textAlign:"center" }}>{option?.name}</div>
                                        )}
                                        style={{ width: 250,paddingTop: "10px", color: "#fff" }}
                                        renderInput={(params) => <TextField {...params} label="User" variant="outlined" />}
                                        getOptionSelected={(o, v) => o.id === v.id}
                                        onChange={(e, o) => {
                                                setUser(o);
                                            }}
                                        />
                                </Grid>
                                <Grid item xs={1} />
                                <Grid item xs={5}
                                    container={true}
                                    alignContent="flex-start">
                                    <Autocomplete
                                        value={createdBy || {}}
                                        id="createdBy"
                                        options={queryParams?.meterReaders?.sort((a,b) => a.name.localeCompare(b.name)) ?? []}
                                        getOptionLabel={(option) => option?.name ?? ""}
                                        renderOption={(option, { selected }) => (
                                            <div style={{ width: "100%", textAlign:"center" }}>{option?.name}</div>
                                        )}
                                        style={{ width: 250,paddingTop: "10px", color: "#fff" }}
                                        renderInput={(params) => <TextField {...params} label="Created By" variant="outlined" />}
                                        getOptionSelected={(o, v) => o.id === v.id}
                                        onChange={(e, o) => {
                                                setCreatedBy(o);
                                            }}
                                        />
                                </Grid>
                            </div>
                            <div className="row col-6">
                                <Grid item xs={1}></Grid>
                                <Grid item xs={12}>
                                    <div style={{textAlign: "left",paddingLeft: '15px'}}>Search for meter images using any of the search parameters provided.</div>
                                    <div style={{textAlign: "left",paddingLeft: '15px'}}>You must provide at least a meter route or meter to search for images.</div>
                                </Grid>
                            </div>
                            <div className="row col-12" style={{ paddingLeft: '15px', paddingBottom: '15px', margin:'0px' }}>
                                <Grid item xs={1}>
                                    <Button onClick={() => loadIframe()} color="primary">
                                        Submit
                                    </Button>
                                </Grid>
                                <Grid item xs={1}>
                                    <Button onClick={handleReset}>
                                        Reset
                                    </Button>
                                </Grid>
                            </div>
                        </div>
                    </div>
                    <iframe id="meter-images"
                        title="meter-images"
                        src={`${url}/#/app/meter-images`}
                        width="1600px"
                        height="1100px"
                        onLoad={() => count > 1 ? null : loadIframe()}
                        style={{border: "none", display:"block", marginLeft:"25px"}} />
                </div>
            </Container>
        </React.Fragment>
    );
}